export enum HeaderTestIds {
  Container = 'header-container',
  HomeButton = 'header-home-button',
  BoardsMenuButton = 'header-boards-menu-button',
  SearchInput = 'header-search-input',
  CreateMenuButton = 'header-create-menu-button',
  InfoButton = 'header-info-button',
  NotificationsButton = 'header-notifications-button',
  EnterpriseDashboardButton = 'header-enterprise-dashboard-button',
  ChannelPickerButton = 'header-channel-picker-button',
  MemberMenuButton = 'header-member-menu-button',
}

export enum HomeTestIds {
  CardTitle = 'home-card-title',
  DismissOrientationCard = 'home-dismiss-orientation-card-',
  HighlightsList = 'home-highlights-list',
  HomeLink = 'home-link',
  MyTeamCardsLink = 'home-my-team-cards-link',
  NavigationCreateTeamButton = 'home-navigation-create-team-button',
  TeamTabName = 'home-team-tab-name',
  TeamTabSection = 'home-team-tab-section-',
  UpNextList = 'home-up-next-list',
}

export enum PowerUpTestIds {
  SearchInput = 'pup-search-input',
  AddPowerUpButton = 'pup-add-button',
  PowerUpsList = 'pup-list',
  LargePowerUpIcon = 'pup-large-icon',
  BoardSelector = 'pup-board-selector',
  SelectedBoard = 'pup-selected-board',
  AddToBoardButton = 'pup-add-to-board-button',
  SuccessHeading = 'pup-success-heading',
  GoToBoardButton = 'pup-go-to-board-button',
}

export enum TeamTestIds {
  TeamMembersLink = 'team-members-link',
}



// WEBPACK FOOTER //
// ./app/common/data/test-ids.ts